export const extractNumber = (inputString: string): number => {
  const match = inputString.match(/[\d,]+\.?\d*/)
  const numberAsString = match ? match[0] : null
  if (!numberAsString) {
    return 0
  }

  return parseFloat(numberAsString.replace(/,/g, ''))
}
